<template>
	<Container>
		<TopBar />
		<div class="content">
			<div class="order-detail">
				<div class="order-head">
					<div :lg='8' class='order-left'>
						<p class="order-info">訂單信息(Order Information)<span v-if='orderDetail.OptVipNo' v-text='forOrder(orderDetail)'></span></p>
						<div style="margin-left: 0.1rem;">
							<Row style="margin-top: 0.1rem;">
								<Col span='12'>訂單編號(Order Number):</Col>
								<Col span='12'>{{orderDetail.OrderNo}}</Col>
							</Row>
							<Row style="margin-top: 0.1rem;">
								<Col span='12'>訂單類型(Order Type):</Col>
								<Col span='12'>{{orderDetail.Catalog}}&nbsp;<template v-if='orderDetail.LRPTemplateType==11'>Template</template>&nbsp;<template v-if='orderDetail.VirtualFlag==20'>(贈品單)</template></Col>
							</Row>
							<Row style="margin-top: 0.1rem;">
								<Col span='12'>訂單渠道(Order Channel):</Col>
								<Col span='12'>{{orderDetail.Channel}}</Col>
							</Row>
							<Row style="margin-top: 0.1rem;">
								<Col span='12'>支付類型(Payment Type):</Col>
								<Col span='12'>{{orderDetail.OrderType}}</Col>
							</Row>
							<Row style="margin-top: 0.1rem;">
								<Col span='12'>支付方式(Payment Method):</Col>
								<Col span='12'>{{channelType(orderDetail.PayChannel)}}</Col>
							</Row>
							<Row style="margin-top: 0.1rem;" v-if='getPromoCode()'>
								<Col span='12'>優惠(簽到)碼(Promo Code):</Col>
								<Col span='12'>{{(getPromoCode())}}</Col>
							</Row>
							<Row style="margin-top: 0.1rem;">
								<Col span='12'>收貨地址(Delivery Address):</Col>
								<Col span='12'>{{address}}
								<span v-if='canEditAddress' style="color: #BC86C8;text-decoration: underline;cursor: pointer;" @click='changeAddress'>修改地址 Update Address</span>
								</Col>
							</Row>
							<Row style="margin:0.1rem auto;">
								<Col span='12'>聯絡電話 (Contact Number):</Col>
								<Col span='12'>{{delivery.MobliePhone}}</Col>
							</Row>
							<Row style="margin:0.1rem auto;" v-if="orderDetail.Proxy">
								<Col span='12'>團隊合併自提 Leader Group Pickup:</Col>
								<Col span='12'>{{orderDetail.Proxy}}</Col>
							</Row>
						</div>
					</div>
					<div class='track'>
						<!-- <div style="flex:1">
							<h3>物流信息(Logistics Information)</h3>
							<div class="track-detail">
								<p><span v-if='delivery.DeliveryStoreId == "501"'>{{delivery.ShippersName}}</span><span v-if='delivery.ExpressNo'>:{{delivery.ExpressNo}}</span> <Button class='show-btn' type='text' @click='showTrack=true' v-if='expressUrl&&delivery.DeliveryStoreId =="501"'>查看物流詳情</Button></p>
								<p v-if="delivery.DeliveryStoreId && delivery.DeliveryStoreId != '501'">精油生活館地址: {{delivery.Address}}</p>
								<Modal v-model='showTrack' title="物流詳情" width='600'>
									<iframe :src="expressUrl" class="track-list"></iframe>
								</Modal>
							</div>
						</div>
						<div style="flex:1">
							<h3>發票信息(Invoice Information)</h3>
							<div class="track-detail">
								<p v-show="InvoiceLoad">{{InvoiceStatusText}}
									<a class='orderdetail-down' target="_blank" v-show="invoice.InvoiceStatus=='10'" v-on:click="InvoinceDown">下載發票</a>
									<a class='orderdetail-down' target="_blank" v-show="CanCancelInvoice" v-on:click="InvoinceCancel">作廢發票</a>
									<Button class='show-btn' type='text' @click='showInvoice=true' v-show='canInvoice'>{{InvoiceStatusBtnText}}</Button>
								</p>
								<p style="font-size: 13px;">請在訂單完成後的一個月內申請開具電子發票，如發票開具有誤請在開具後的30天內申請發票作廢，逾期後已開具的電子發票無法進行任何修改</p>
								<Modal v-model='showInvoice' title="發票詳情" width='600' ok-text="提交">
									<table class="Invoice-list">
										<tbody>
											<tr>
												<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>類型:</td>
												<td class="Invoice-content">
													<span v-if="InvoiceStatus==0">
														<RadioGroup v-model="invoice.CompanyTypeText" type="button" size="large">
															<Radio label="個人"></Radio>
															<Radio label="企業"></Radio>
															<Radio label="機關事業單位"></Radio>
														</RadioGroup>
													</span>
													<span v-else>
														{{invoice.CompanyTypeText}}
													</span>
												</td>
												<td class="Invoice-right"></td>
											</tr>
											<tr>
												<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>發票擡頭:</td>
												<td class="Invoice-content">
													<span v-if="InvoiceStatus==0 && isPersonal">
														<input type="text" class="ivu-input" v-model="invoice.InvoiceTitle" maxlength="50">
													</span>
													<span v-else>
														<Select v-model="invoice.InvoiceTitle" size="large">
															<Option  value="個人" key="個人">個人</Option>
															<Option  :value="userInfo.value.binding.name" :key="userInfo.value.binding.name">{{userInfo.value.binding.name}}</Option>
														</Select>
													</span>
												</td>
												<td></td>
											</tr>
											<tr v-show="InvoiceStatus==0 && isPersonal">
												<td class="Invoice-head"></td>
												<td>
													<Select v-model="invoiceCompany" size="large" @on-change="chooseInvoiceInfo()">
														<Option v-for="(item,index) in invoiceInfo" :value="index" :key="item.Id">{{ item.InvoiceTitle }}</Option>
													</Select>
												</td>
												<td class="Invoice-right">
													<Button type="primary" class="btn-invoiceDelete" @click="deleteInvoiceInfo">刪除</Button></td>
											</tr>
											<tr v-show='isPersonal && showTaxPayerId'>
												<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>納稅人識別號:</td>
												<td class="Invoice-content">
													<input type="text" class="ivu-input" v-model="invoice.TaxPayerId" v-if="InvoiceStatus==0" @blur="invoice.TaxPayerId=invoice.TaxPayerId.toUpperCase()"
													 maxlength="20">
													1234567890
													<span v-else>
														{{invoice.TaxPayerId}}
													</span>
												</td>
												<td class="Invoice-right" rowspan="6"></td>
											</tr>
											<tr v-show='isPersonal'>
												<td class="Invoice-head">地址:</td>
												<td class="Invoice-content">
													上海
													<input type="text" class="ivu-input" v-model="invoice.Address" v-if="InvoiceStatus==0" maxlength="50">
													<RadioGroup v-model="invoice.Address" type="button" size="large" v-if="InvoiceStatus==0">
															<Radio label="上海" selected="true"></Radio>
														</RadioGroup>
													<span v-else>
														{{invoice.Address}}
													</span>
												</td>
											</tr>
											<tr v-show='isPersonal'>
												<td class="Invoice-head">電話:</td>
												<td class="Invoice-content">
													<input type="text" class="ivu-input" v-model="invoice.Phone" v-if="InvoiceStatus==0" maxlength="20">
													15000000000
													<span v-else>
														{{invoice.Phone}}
													</span>
												</td>
											</tr>
											<tr v-show='isPersonal'>
												<td class="Invoice-head">開戶銀行:</td>
												<td class="Invoice-content">
													<input type="text" class="ivu-input" v-model="invoice.BankName" v-if="InvoiceStatus==0" maxlength="20">
													招商銀行閔行支行
													<span v-else>
														{{invoice.BankName}}
													</span>
												</td>
											</tr>
											<tr v-show='isPersonal'>
												<td class="Invoice-head">銀行賬號:</td>
												<td class="Invoice-content">
													<input type="text" class="ivu-input" v-model="invoice.BankNo" v-if="InvoiceStatus==0" maxlength="20">
													60000000000000
													<span v-else>
														{{invoice.BankNo}}
													</span>
												</td>
											</tr>
										</tbody>
									</table>
									<div slot="footer">
										<Button type="text" v-show="InvoiceStatus==0" v-on:click="cancelInvoice()">取消</Button>
										<Button type="primary" v-on:click="submitInvoice()">確定</Button>
									</div>
								</Modal>
								<Modal v-model='showInvoiceLink' title="發票文件" width='600'>
									您的發票文件已生成，點擊確認後開始下載或者輸入郵箱地址，我們將通過郵件發送給您。<br>
									<input type="text" class="ivu-input" v-model="InvoiceEmail" maxlength="50" placeholder="郵箱地址">
									<div slot="footer">
										<Button type="text" v-on:click="cancelInvoiceLink()">取消</Button>
										<a v-bind:href="pdfUrl" target="_blank" class="orderdetail-downLink ivu-btn ivu-btn-primary">下載</a>
										<Button type="text" v-on:click="PostInvoiceEmail()" class="ivu-btn ivu-btn-primary">發送郵件</Button>
									</div>
								</Modal>
								<Modal v-model='confirmInvoice' title="信息" width='600' ok-text="確認" @on-ok="postInvoice">
									請再次確認納稅人識別號是否正確
								</Modal>
							</div>
						</div> -->
					</div>
				</div>
				<Table class='products orderTable' stripe :columns="columns" :data="products"></Table>
				<Row style="background-color: #f3f3f3;margin-top: 0.5rem;">
					<Col :lg='{span:12, push:12}' class="fee">
						<Row>
							<Col :lg='12' :xs='18' style='font-size: 0.12rem;'>産品總價(Sub Total)：</Col>
							<Col :lg='12' :xs='6' style='font-size: 0.12rem;'>HK${{orderDetail.ProductPrice?orderDetail.ProductPrice.toFixed(2):'0.00'}}</Col>
							<Col :lg='12' :xs='18' style='font-size: 0.12rem;'>産品點數(Total PV)：</Col>
							<Col :lg='12' :xs='6' style='font-size: 0.12rem;'>{{orderDetail.PValue?orderDetail.PValue.toFixed(2):'0.00'}}</Col>
							<!-- <Col :lg='12' :xs='18'>兌換點數(Redeem Point)：</Col>
							<Col :lg='12' :xs='6'>{{orderDetail.Point?orderDetail.Point.toFixed(2):'0.00'}}</Col> -->
							<!-- <template v-if='showPT'>
								<Col :lg='12' :xs='18'>服務費：</Col>
								<Col :lg='12' :xs='6'>HK${{orderDetail.ServiceFee?orderDetail.ServiceFee.toFixed(2):'0.00'}}</Col>
							</template> -->
							<Col :lg='12' :xs='18' style='font-size: 0.12rem;'>配送費/手續費(Delivery Fee/Handling Charge)：</Col>
							<Col :lg='12' :xs='6' style='font-size: 0.12rem;'>
							<div class="mdeliveryFemv" v-if='free>0'>
								<div style="color: rgb(255, 70, 29);border-color: rgb(255, 70, 29);">
									<p style="color: rgb(255, 70, 29);">免{{free.toFixed(2)}}</p>
								</div>
							</div>
							<p style="width:initial;float:left" class="ellipsis" :class="{add_x: free > 0, move_x:(sys_deliveryFee-free)>0}" v-text='resuldeliveryFee()'></p>
							</Col>
						
							<!-- <Col v-if="orderDetail.ABValue>0" :lg='12' :xs='18'>賬戶餘額(Account Balance)：</Col> -->
							<!-- <Col v-if="orderDetail.ABValue>0" :lg='12' :xs='6'>HK${{orderDetail.ABValue?orderDetail.ABValue.toFixed(2):'0.00'}}</Col> -->
					
							
							<!-- <Col :lg='12' :xs='18' style='color:orange'>産品積分支付(Product Credits)：</Col>
							<Col :lg='12' :xs='6' style='color:orange'>HK${{orderDetail.ARValue?orderDetail.ARValue.toFixed(2):'0.00'}}</Col> -->
						
							<Col :lg='12' :xs='18' style='font-weight: bold;font-size: 0.16rem;'>應支付金額 (Order Total):</Col>
							<Col :lg='12' :xs='6' style='font-weight: bold;font-size: 0.16rem;'>HK${{orderDetail.TotalPaid?orderDetail.TotalPaid.toFixed(2):'0.00'}}</Col>
						</Row>
						<Col span='24' style='margin-top: 30px;' v-if='(orderDetail.OrderStatus=="UnPay"||orderDetail.OrderStatus=="Paying")&&(orderDetail.OptVipNo==null||orderDetail.OptVipNo==vipNo)&&((orderDetail.Channel=="HK"||orderDetail.Channel=="Manual"))'>
							<Button @click='gotoPay' size='large' type='primary' style='margin-right: 40px;font-size:0.14rem'>繼續付款(Continue to pay)</Button>
							<Button @click='qxpay' size='large' type='primary' style='font-size:0.14rem'>取消訂單(Cancel Order)</Button>
						</Col>
					</Col>
				</Row>
			</div>
		</div>
		<editAddressView title='修改收貨人' :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='addressLoading'></editAddressView>
	</Container>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import { api_methods } from "@/service/loadData";
import editAddressView from "@/components/order/editAddressView";
import util from "@/config/util";
import {RE_EMAIL} from '@/components/common/regex';
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
	data() {
		return {
			columns: [
				{
					key: "Name",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "商品"),
							h("div", null, "Product")
						]);
					}
				},
				{
					key: "UnitPrice",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "單價"),
							h("div", null, "Unit Price")
						]);
					}
				},
				{
					key: "UnitPV",
					renderHeader: (h, index) => {
						return h("div", [h("div", null, "PV")]);
					}
				},
				{
					key: "Quantity",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "數量"),
							h("div", null, "quantity")
						]);
					}
				},
				{
					key: "subTotal",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "金額小計"),
							h("div", null, "SubTotal")
						]);
					},
					render: (h, params) => {
						let innerHtml =
							params.row.UnitPrice * params.row.Quantity;
						return h("div", null, innerHtml);
					}
				}
			],

			products: [],
			delivery: {},
			expressUrl: null,
			sys_deliveryFee: 0,
			free: 0,
			from: "orders",
			showTrack: false,
			showInvoice: false,
			invoice: {
				TaxPayerId: "",
				InvoiceTitle: "個人",
				CompanyTypeText: "個人",
				CompanyType: "03",
				Address: "上海",
				Phone: "",
				BankName: "",
				BankNo: "",
				Email: "",
				ID: 0
			},
			orderInvoice: {},
			invoiceInfo: {},
			invoiceCompany: "",
			InvoiceLoad: false,
			CanCancelInvoice:false,
			showInvoiceLink: false,
			InvoiceEmail:'',
			pdfUrl: '',
			confirmInvoice: false,
			InvoiceStatusBtnText: "申請開具發票",
			loading: true,
			canInvoice: true,
			editAddress: {
				id: 0,
				name: null,
				province_id: null,
				moblie_phone: null,
				city_id: null,
				county_id: null,
				town_id: null,
				street: null,
				street2: null,
				zip: null,
				email: null,
				wechatno: null,
				is_default: "0",
				tag_type: "0",
				address_type: "1"
			},
			show: false,
			addressLoading: false,
			omsOrderDetail:{},
		};
	},
	created() {
		this.$nextTick(function() {
			this.initData();
			this.vipNo = this.getVipNo;
		});
	},
	mounted() {},
	watch: {
		'invoice.CompanyTypeText'(value) {
				this.invoice.CompanyType=this.CompanyType;
				if (this.InvoiceStatus == 0) {
					if (value == '個人') {
						this.invoice.InvoiceTitle = '個人';
						this.showTaxPayerId=true;
					}
					else if (value == '企業') {
						if (this.invoice.InvoiceTitle == '個人') {
							this.invoice.InvoiceTitle = this.userInfo.value.binding?.company?.company_name || '個人';
						}
						if (this.userInfo.value.binding.customer_type.toLowerCase() == 'vipbiz' || this.userInfo.value.binding.customer_type.toLowerCase() == 'sa') {
							if (this.invoice.InvoiceTitle == '') {
								this.invoice.InvoiceTitle = this.userInfo.value.binding?.company?.company_name || '';
							}
							if (this.invoice.Phone == '') {
								this.invoice.Phone = this.userInfo.value.binding.moblie_phone;
							}
							if (this.invoice.BankName == '') {
								this.invoice.BankName = this.userInfo.value.binding.bank.bank_name;
							}
							if (this.invoice.BankNo == '') {
								this.invoice.BankNo = this.userInfo.value.binding.bank.account_number;
							}
							if (this.invoice.Email == '') {
								this.invoice.Email = this.userInfo.value.binding.email;
							}
							if (this.invoice.Address == '上海' || this.invoice.Address == '') {
								this.invoice.Address = this.userInfo.value.binding?.company?.business_street || this.invoice.Address;
							}
						}
						else if (this.userInfo.value.binding.customer_type.toLowerCase() == 'pc') {
							if (this.invoice.Phone == '') {
								this.invoice.Phone = this.userInfo.value.binding.moblie_phone;
							}
						}
						this.showTaxPayerId=true;
					}
					else if(value == '機關事業單位'){
						this.showTaxPayerId=false;
					}
					else {
						if (this.invoice.InvoiceTitle == '個人') {
							this.invoice.InvoiceTitle = '';
						}
						this.showTaxPayerId=true;
					}
				}
			}
	},
	mixins: [],
	components: {
		TopBar,
		editAddressView
	},
	computed: {
		...mapGetters(["getVipNo"]),
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			orderDetail: state => state.order.orderDetail,
			sysConfig: state => state.common.sysConfig
		}),
		address() {
			return `${this.delivery.ProvinceName||''} ${this.delivery.CityName||''} ${this.delivery.Street||''} ${this.delivery.Street2||''}`;
		},
		actualPay() {
			let actualPay =
				parseFloat(this.order.grandTotal) -
				parseFloat(this.order.totalAr);
			return actualPay.toFixed(2);
		},
		showPT: function() {
			if (this.orderDetail.Placetime >= this.sysConfig?.value.pt_endtime) {
				return false;
			} else {
				return true;
			}
		},
		canEditAddress() {
			if (this.orderDetail.VirtualFlag) {
				return false	
			}	
			let editable = true;
			if (
				this.orderDetail.OrderStatus == "Cancel" ||
				this.orderDetail.OrderStatus == "Close"
			) {
				editable = false;
			}
			if (this.orderDetail.Paytime) {
				let now = new Date();
				let payTime = util.formatDate.dateFromStr(
					this.orderDetail.Paytime
				);
				if (now - payTime > 7200000) {
					editable = false;
				}
			}
			return editable;
		},
		CompanyTypeText() {
				//01：企業  02：機關事業單位 03：個人  04：其它
				if (this.invoice.CompanyType == '01') {
					return '企業'
				}
				else if (this.invoice.CompanyType == '02') {
					return '機關事業單位'
				}
				else if (this.invoice.CompanyType == '03') {
					return '個人'
				}
				else if (this.invoice.CompanyType == '04') {
					return '其他'
				}
				return '個人'
		},
		CompanyType() {
			//01：企業  02：機關事業單位 03：個人  04：其它
			if (this.invoice.CompanyTypeText == '企業') {
				return '01'
			}
			else if (this.invoice.CompanyTypeText == '機關事業單位') {
				return '02'
			}
			else if (this.invoice.CompanyTypeText == '個人') {
				return '03'
			}
			else if (this.invoice.CompanyTypeText == '其他') {
				return '04'
			}
			return '03'
		},
		InvoiceStatus() {
			if (this.invoice.InvoiceStatus == "00" || this.invoice.InvoiceStatus == "10") {
				return 1;//發票開具中\已開具發票，直接顯示發票信息，不能再次申請
			}
			else {
				return 0;
			}
		},
		InvoiceStatusText() {
			if (this.invoice.InvoiceStatus == "00") {
				return "發票開具中"
			}
			else if (this.invoice.InvoiceStatus == "10") {
				return "已開具發票"
			}
			else if (this.invoice.InvoiceStatus == "-1") {
				return "開票失敗"//開票失敗，顯示上次開票信息，可以再次申請
			}
			else{
				return "未開具發票";
			}
		},
		isPersonal() {
			if (this.invoice.CompanyType == '03') {
				return false;
			}
			else {
				return true;
			}
		}
	},
	methods: {
		...mapMutations(["SET_ORDERNN"]),
		...mapActions([
			"getWXOrderDetailAction",
			"getOrderInvoiceAction",
			"getInvoiceInfoAction",
			"postOrderInoviceAction",
			"postInvoiceInfoAction",
			"postDeleteInvoiceInfoAction",
			'GetInvoiceDownAction',
			'getInvoiceEmailAction',
			'GetInvoiceCancelAction',
			'postInvoiceEmailAction',
			"getOrderEncryptionAction",
			"changeOrderAddressAction",
			"postAddAddressAction",
			'getOMSOrderDetailAction',

		]),
		async initData() {
			let orderno = this.$route.query.orderNo;
			// if(this.userInfo&&this.userInfo.value&&this.userInfo.value.binding){
			// 	if(this.userInfo.value.binding.user_id!=this.orderDetail.CustomerId){
			// 		this.$router.push("/order/orders");
			// 		return
			// 	}
			// }
			let response = await this.getWXOrderDetailAction(orderno);
			if (response) {
				this.delivery = response.delivery[0] || {};
				this.lrptType = this.delivery.LRPTemplateType
				var products = response.group || [];

				this.products = products.filter(u =>
					this.showProductPromote(u)
				);
				this.expressUrl = response.expressUrl;
			}
			console.log(this.orderDetail)
			if (this.orderDetail && this.orderDetail.PayChannel || this.orderDetail.orderId) {
				let response1 = await this.getOMSOrderDetailAction(orderno);
				if (response1 && response1.orderStatus) {
					this.omsOrderDetail = response1
					this.initDataInvoice()
				}
			}

			if (this.orderDetail.DeliveryStoreId == "501" && !this.delivery.PromoCode &&this.orderDetail.VirtualFlag==0) {
				//取係統設置配送費
				if(this.orderDetail.ProductPrice >= 2000){
					this.sys_deliveryFee = this.delivery.Province == '110000' ? this.sysConfig.value.float_delivery_fee_hongkong : this.sysConfig.value.float_delivery_fee_macao;
				}
				this.free = this.sys_deliveryFee - this.orderDetail.ExpressFee;
			} else if (this.orderDetail.DeliveryStoreId == "501" && !this.delivery.PromoCode &&[1,2,6].includes(this.orderDetail.VirtualFlag)) {
				this.free = this.sys_deliveryFee - this.orderDetail.ExpressFee;
			} else if (this.delivery.PromoCode) {
				this.sys_deliveryFee = this.orderDetail.ExpressFee;
				this.free = this.sys_deliveryFee - this.orderDetail.ExpressFee;
			}
		},
		showProductPromote(item) {
			if (item.ProductFlag != 1) {
				return true;
			} else {
				if (!this.orderDetail.Paytime) {
					return true;
				} else if (!item.PromoteEnd) {
					return true;
				} else if (item.PromoteEnd > this.orderDetail.Paytime) {
					return true;
				}
				return false;
			}
		},
		async gotoPay() {
			var res = await this.getOrderEncryptionAction(
				this.orderDetail.OrderNo
			);
			if (res) {
				this.SET_ORDERNN({
					orderno: res,
					os: this.orderDetail.OrderNo
				});
				this.$router.push("/order/confirm");
			}
		},
		async changeAddress() {
			this.editAddress = {
				id: 0,
				orderNo: this.orderDetail.OrderNo,
				name: this.delivery.Name,
				province_id: parseInt(this.delivery.Province),
				city_id: parseInt(this.delivery.City),
				county_id: parseInt(this.delivery.County),
				town_id: parseInt(this.delivery.Town),
				street: this.delivery.Street,
				street2: this.delivery.Street2,
				zip: this.delivery.Zip,
				email: this.delivery.Email,
				wechatno: this.delivery.WechatNo,
				moblie_phone: this.delivery.MobliePhone,
				address_type: 2,
				tag_type: "",
				is_default: false,
				whetherAddress: false
			};
			this.show = true;
		},
		async asyncOK(address) {
			this.addressLoading = true;
			var obj = {
				Id: address.id,
				Name: address.name,
				MobliePhone: address.moblie_phone,
				Province: address.province_id,
				City: address.city_id,
				County: address.county_id,
				Town: address.town_id,
				Street: address.street,
				Street2: address.street2,
				Zip: address.zip,
				Email: address.email,
				WechatNo: address.wechatno,
				AddressType: address.address_type,
				Tags: address.tag_type,
				IsDefault: address.is_default ? 1 : 0,
				CustomerId: this.userInfo.value.binding.user_id,
				orderNo: this.orderDetail.OrderNo,
				Remark: ""
			};
			let response = await this.changeOrderAddressAction(obj);
			if (response > 0) {
				if (address.whetherAddress) {
					await this.postAddAddressAction(obj);
				}
				this.$Message.success("地址修改成功");
				await this.initData();
			} else {
				let message = "";
				if (response == -1) {
					message =
						"訂單不存在或者訂單已經發貨或者已經取消不可以修改";
				} else if (response == -2) {
					message = "訂單正在處理中，請稍後修改";
				} else {
					message = "地址修改失敗";
				}
				this.$Message.error(message);
			}
			this.show = false;
			this.addressLoading = false;
		},
		qxpay() {
			this.$Modal.confirm({
				title: "取消訂單",
				content: "確定要取消訂單嗎？",
				onOk: () => {
					api_methods
						.CancelOrder(
							this.getAccessToken,
							this.getUserId,
							this.orderDetail.OrderNo
						)
						.then(result => {
							if (
								result &&
								result.data &&
								result.data.value == 1
							) {
								this.$parent.reload = true;
								this.$router.go(-1);
							} else {
								this.$Modal.info({
									title: "信息",
									content: "訂單取消失敗"
								});
							}
						});
				}
			});
		},
		resuldeliveryFee() {
			var Fee = this.sys_deliveryFee - this.free;
			return Fee > 0
				? "HK$" + Fee.toFixed(2)
				: "HK$" + this.sys_deliveryFee.toFixed(2);
		},
		channelType(item) {
			// alert(item)
			item = item && item.toLowerCase();
			if (item == "wechat") {
				return "微信(Wechat)";
			}
			if (item == "alipay") {
				return "支付寶(AliPay)";
			}
			if (item == "llzf") {
				return "銀聯(Union Pay)";
			}
			if (item == "together") {
				return "聚合碼銀聯支付";
			}
			if (item == "unionapp") {
				return "雲閃付";
			}
			if (item == "visa") {
				return "Visa支付";
			}
			if (item == "mastercard") {
				return "Master支付";
			}
			if (item == "wechatpay") {
				return "微信(Wechat)";
			}
			if (item == "unionpay") {
				return "銀聯(UnionPay)";
			}
			if (item == "alipay") {
				return "支付寶(AliPay)";
			}
			if (item == "alipay_hk") {
				return "支付寶(AliPay)";
			}
			if(this.orderDetail.TotalPaid==0){
				return "賬戶餘額支付";
			}
		},
		forOrder(item) {
			if (item.OptVipNo == this.getVipNo) {
				//幫別人下單
				return "協助顧客訂購:" + this.passwordName(item.Name);
			}
			if (item.VipNo == this.getVipNo) {
				//別人幫我下單
				return this.passwordName(item.OptName) + "（協助下單）";
			}
		},
		passwordName(name) {
			var newName = "";
			if (name) {
				if (name.length > 2) {
					newName =
						name.charAt(0) + "*" + name.charAt(name.length - 1);
				} else {
					newName = name.charAt(0) + "*";
				}
			}
			return newName;
		},
		convertChannel(channel) {
				switch (channel.toLowerCase()) {
					case 'wx':
						return "微信訂單"
					case 'wechat':
						return "微信訂單"
					case 'oms':
						return "客服門店訂單"
					case 'mg':
						return "網絡訂單"
					case 'myo':
						return 'MyO訂單'
					case 'moblieapp':
						return 'MobileApp訂單'
					default:
						return channel+'訂單'
						break;
				}
			},
		// 開票相關
		async initDataInvoice() {
				this.CanCancelInvoice = false;

				//canInvoice
				if (this.omsOrderDetail.orderStatus == '30' || this.omsOrderDetail.channel == "HWG"||this.orderDetail.VirtualFlag == 20 ) {
					//訂單狀態：作廢，隱藏審核發票按鈕
					this.canInvoice = false;
					return;
				}

				//判斷訂單是否超過30天
				var now = new Date();
				var DateAdd30 = new Date(now.getFullYear(), now.getMonth()- 1, now.getDate());
				//console.log('DateAdd30');
				//console.log(DateAdd30.getFullYear()+'-'+DateAdd30.getMonth()+'-'+DateAdd30.getDate())
				//var DateAdd30 = new Date();
				var createTime = Date.parse(this.omsOrderDetail.createTime.replace(/-/g, '/'));
				// var isEffective = false;
				// if (DateAdd30.getTime() <= createTime) {
				// 	isEffective = true;
				// }
				//var OpenDay=new Date(2018, 11, 16);
				console.log('Valid OpenDay')
				console.log(this.omsOrderDetail.createTime)
				var OpenDay=new Date(2018, 11, 16);
				if(createTime<OpenDay.getTime()){
					this.canInvoice = false;
					console.log('Valid OpenDay Close')
					return;
				}
				else{
					console.log('Valid OpenDay Open')
				}

				//查詢申請的發票信息
				let orderno = this.$route.query.orderNo;
				let responseOrderInvoice = await this.getOrderInvoiceAction(orderno);
				console.log('發票申請信息');
				console.log(responseOrderInvoice);
				if (responseOrderInvoice) {
					if(responseOrderInvoice.Value2>0){
						this.canInvoice = false;
						return;
					}
					if (responseOrderInvoice.Value.length >= 1) {
						this.invoice = responseOrderInvoice.Value[0];
						this.invoice.CompanyTypeText=this.CompanyTypeText;
						this.InvoiceStatusBtnText = '查看發票詳情'

						var createTime = Date.parse(this.invoice.CreateTime.replace(/-/g, '/'));
						
						if (DateAdd30.getTime() <= createTime && this.invoice.InvoiceStatus=='10' && this.invoice.IsCancel==0) {
							this.CanCancelInvoice = true;
						}
						console.log('this.CanCancelInvoice:'+this.CanCancelInvoice)
					}
					else
					{
						this.invoice={
							TaxPayerId: '',
							InvoiceTitle: '個人',
							CompanyTypeText: '個人',
							CompanyType: '03',
							Address: '上海',
							Phone: '',
							BankName: '',
							BankNo: '',
							Email: '',
							InvoiceStatus: '0'
						}
						
						this.InvoiceStatusBtnText='申請開具發票'
					}
				}

				// if (this.InvoiceStatus == 0 && isEffective == false) {
				// 	//未提交過發票信息且超過訂單時間30天，隱藏申請發票按鈕
				// 	this.canInvoice = false;
				// 	return;
				// }

				if(this.InvoiceStatus == 0){
					//未開票時，查詢發票擡頭記錄曆史列錶，文本框填充上次申請的記錄
					let responseInvoiceInfo = await this.getInvoiceInfoAction(orderno);
					console.log('發票擡頭記錄曆史列錶');
					console.log(responseInvoiceInfo);
					if (responseInvoiceInfo) {
						this.invoiceInfo = responseInvoiceInfo;

						//初始化
						if (this.invoiceInfo.length != 0) {
							this.invoiceCompany = this.invoiceInfo.length - 1;

							// this.invoice.CompanyTypeText = '企業';
							// this.invoice.CompanyType = '01';
							this.chooseInvoiceInfo();
						}
					}
					console.log('開票狀態');
					console.log(this.InvoiceStatus);
				}
				this.InvoiceLoad = true;//加載完成，顯示發票模塊
			},
			async cancelInvoice() {
				this.showInvoice = false;
			},
			async submitInvoice() {
				if (this.invoice.InvoiceTitle == '') {
					this.$Modal.info({
						title: '信息',
						content: '請填寫發票擡頭'
					});
					return;
				}
				if (!/^[\u4e00-\u9fa5a-zA-Z0-9()（）]+$/.test(this.invoice.InvoiceTitle)) {
					this.$Modal.info({
						title: '信息',
						content: '發票擡頭不能含有特殊字符，請確認後重新輸入'
					});
					return;
				}

				if (this.InvoiceStatus == 0) {
					let orderno = this.$route.query.orderNo;
					//驗證納稅人識別號格式，排除個人和機關事業單位的類型
					if (this.invoice.CompanyType != '03' && this.invoice.CompanyType != '02' ) {
						if (this.invoice.TaxPayerId == '') {
							this.$Modal.info({
								title: '信息',
								content: '請填寫納稅人識別號'
							});
							return;
						}
						if (this.invoice.TaxPayerId.length != 18 && this.invoice.TaxPayerId.length != 15) {
							//this.confirmInvoice=true;識別號錯誤允許提交
							this.$Modal.info({
								title: '信息',
								content: '您輸入的納稅人識別號有誤，請確認後重新輸入'
							});
							return;
						}
						// var reg = /^[1-9]+[0-9]*]*$/; //判斷字符串是否為數字 ，判斷正整數用/^[1-9]+[0-9]*]*$/
						// if (!reg.test(this.invoice.TaxPayerId) && this.invoice.TaxPayerId.length == 15) {
						// 	this.$Modal.info({
						// 		title: '信息',
						// 		content: '您輸入的納稅人識別號格式有誤，請確認後重新輸入'
						// 	});
						// 	return;
						// }
						var re = /^[0-9a-zA-Z]*$/g;  //判斷字符串是否為數字和字母組合     //判斷正整數 /^[1-9]+[0-9]*]*$/  
						if (!re.test(this.invoice.TaxPayerId)) {
							this.$Modal.info({
								title: '信息',
								content: '您輸入的納稅人識別號格式有誤，請確認後重新輸入'
							});
							return;
						}
					}
					else{
						this.invoice.TaxPayerId='';//機關單位類型不需要納稅識別號
					}
					await this.postInvoice();
				}
				else{
					//查看模式，直接關閉
					this.showInvoice = false;
				}
			},
			async postInvoice() {
				let orderno = this.$route.query.orderNo;
				if (this.invoice.CompanyType != '03') {
					if (this.invoiceInfo.length < 10) {
						let responseInvoiceInfo = await this.postInvoiceInfoAction(this.invoice);
						console.log('保存發票擡頭信息');
						console.log(responseInvoiceInfo);
					}
				}
				var argOrderInovice = {
					OrderNo: orderno,
					OriginalID: this.omsOrderDetail.originalID,
					OrderDate: this.omsOrderDetail.createTime,
					InvoiceAmount: this.omsOrderDetail.grandTotal,
					invoice: this.invoice
				}
				let responseOrderInovice = await this.postOrderInoviceAction(argOrderInovice);
				console.log('申請開發票');
				console.log(responseOrderInovice);
				if (responseOrderInovice.Result == 1) {
					//操作成功
					this.$Modal.info({
						title: '信息',
						content: responseOrderInovice.Remark
					});
					this.showInvoice = false;
					this.initDataInvoice()
				}
				else {
					if (responseOrderInovice.Remark) {
						//購貨方納稅人識別號格式錯誤
						if (responseOrderInovice.Remark.indexOf('購貨方納稅人識別號格式錯誤') >= 0) {
							this.$Modal.info({
								title: '信息',
								content: '購貨方納稅人識別號格式錯誤'
							});
						}
						else {
							this.$Modal.info({
								title: '信息',
								content: responseOrderInovice.Remark
							});
						}
					}
					else {
						this.$Modal.info({
							title: '信息',
							content: responseOrderInovice.msg
						});
					}
				}
			},
			async chooseInvoiceInfo() {
				this.invoice.Address = this.invoiceInfo[this.invoiceCompany].Address;
				this.invoice.BankName = this.invoiceInfo[this.invoiceCompany].BankName;
				this.invoice.BankNo = this.invoiceInfo[this.invoiceCompany].BankNo;
				this.invoice.CompanyType = this.invoiceInfo[this.invoiceCompany].CompanyType;
				this.invoice.CompanyTypeText=this.CompanyTypeText;
				this.invoice.Email = this.invoiceInfo[this.invoiceCompany].Email;
				this.invoice.InvoiceTitle = this.invoiceInfo[this.invoiceCompany].InvoiceTitle;
				this.invoice.Phone = this.invoiceInfo[this.invoiceCompany].Phone;
				this.invoice.TaxPayerId = this.invoiceInfo[this.invoiceCompany].TaxPayerId;
				this.invoice.ID = this.invoiceInfo[this.invoiceCompany].ID;
			},
			async deleteInvoiceInfo() {
				let orderno = this.$route.query.orderNo;
				let response = await this.postDeleteInvoiceInfoAction(this.invoiceInfo[this.invoiceCompany].ID);
				console.log(response);
				if (response == 1) {
					//操作成功
					this.$Modal.info({
						title: '信息',
						content: '刪除成功！'
					});
					//刷新發票擡頭列錶
					let responseInvoiceInfo = await this.getInvoiceInfoAction(orderno);
					console.log(responseInvoiceInfo);
					if (responseInvoiceInfo) {
						this.invoiceInfo = responseInvoiceInfo;
					}
				}
				else {
					this.$Modal.info({
						title: '信息',
						content: '刪除失敗！'
					});
				}

			},
			async InvoinceDown() {
				let orderno = this.$route.query.orderNo;
				let reponse = await this.GetInvoiceDownAction(orderno);
				if (reponse.code == 1) {
					//this.$router.push(reponse.pdfUrl);
					// this.$Modal.info({
					// 	title: '信息',
					// 	content: reponse.pdfUrl
					// });
					this.pdfUrl = reponse.pdfUrl;
					this.showInvoiceLink = true;

					//獲取接收發票的郵箱地址
					
					let reponseEmail = await this.getInvoiceEmailAction();
					this.InvoiceEmail=reponseEmail
				}
				else {
					this.$Modal.info({
						title: '信息',
						content: reponse.message
					});
				}
			},
			async InvoinceCancel(){
				var _this=this
				this.$Modal.confirm({
					title: '信息',
					content: '發票作廢後僅有一次重開機會，且重開的發票將無法作廢，請謹慎操作！<br>請再次確認是否需要取消開具的發票？',
					loading:true,
					onOk: async () => {
						let reponse = await _this.GetInvoiceCancelAction(this.invoice.Id);
						if(reponse==1){
							_this.$Modal.info({
								title: '信息',
								content: '取消成功！'
							});
						}
						else{
							_this.$Modal.info({
								title: '信息',
								content: '取消失敗！'
							});
						}
						await _this.initDataInvoice();
						_this.$Modal.remove();
					}
				});
			},
			cancelInvoiceLink() {
				this.showInvoiceLink = false;
			},
			async PostInvoiceEmail(){
				if (this.InvoiceEmail=='') {
					this.$Modal.info({
						title: '信息',
						content: '請輸入郵箱地址！'
					});
					return;
				}

				if (!(RE_EMAIL.test(this.InvoiceEmail))) {
					this.$Modal.info({
						title: '信息',
						content: '郵箱格式不正確請重新輸入！'
					});
					return;
				}
				var params={RecordId:this.invoice.Id,EmailAddress:this.InvoiceEmail}
				let reponse = await this.postInvoiceEmailAction(params);
				if(reponse){
					this.$Modal.info({
						title: '信息',
						content: '發送成功！'
					});
				}
				this.showInvoiceLink = false;
			},
			getPromoCode(){
				let group = this.products||[];
				var code=''
				group.forEach((item)=>{
					if(item.PromoCode){
						code=code+item.PromoCode+','
					}
				}) 
				if(code=='') return null
					return code.substring(0,code.length-1);
			}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.topbar {
	background-color: #f3f4f5;
	a {
		line-height: 40px;
		margin-left: 10.42vw;
		&:hover {
			color: $theme-color;
		}
	}
}
.content {
	padding-top: 10px;
	width: 80%;
	margin: auto;
	list-style: none;
	margin-bottom: 50px;
}
.order-head {
	border: 1px solid rgba(0,0,0,0.05);
	display: flex;
}
.order-detail {
	margin-top: 0.5rem;
}
.order-left {
	border-right: 1px solid rgba(0, 0, 0, 0.05);
	padding: 0;
	color: #666;
	background-color: #fbfbfb;
	font-size: 13px;
	flex:8;
}
.track {
	display:flex;
	flex:12;
	flex-direction: column;
}
.order-info,
.track h3 {
	border-bottom: 1px solid rgba(0, 0, 0, 0.05);
	line-height: 2;
	font-size: 15px;
	padding-left: 16px;
	background-color: #f5f5f5;
	span {
		float: right;
		padding-right: 5px;
		color: #3484e0;
	}
}
.track-detail {
	font-size: 15px;
	line-height: 2.5;
	padding-left: 16px;
	padding-top: 10px;
}

.products {
	margin-top: 0.5rem;
}
.fee {
	line-height: 2;
	padding: 0.5rem 0 0.5rem 0.5rem;
	color: #666;
	font-size: 12px;
}
.add_x {
	text-decoration: line-through;
}
.move_x {
	text-decoration: none;
}
.mdeliveryFemv {
	display: flex;
	position: relative;
	//top: -24px;;
	left: 5px;
	text-align: center;
	display: inline-block;
	div {
		font-size: 14px;
		height: 20px;
		padding: 2.34px;
		border: 1px solid #666;
		border-radius: 7.03px;
		margin-right: 2.34px;
		transform: scale(0.8);
	}
	p {
		white-space: nowrap;
		line-height: 14px;
		font-size: 14px;
	}
}
.show-btn {
	margin-left: 0.2rem;
	color:$theme-color;
}
.track-list {
	width: 100%;
	border: none;
	height: 350px;
}
.Invoice-list {
	line-height: 40px;
	font-size: 14px;
	width: 100%;
}
.Invoice-head {
	text-align: right;
	width: 25%;
	padding-right: 15px;
}
.Invoice-content {
	/*padding-right:20%*/
}
.Invoice-right {
	width: 20%;
}
.btn-invoiceDelete {
	float: left;
}
.invoice-icon {
	color: red;
}
@media (max-width: 768px){
	.content {
		width: 95%;
	}
	.order-head {
		flex-direction: column;
	}
}
</style>